import { render, staticRenderFns } from "./ticket-success.vue?vue&type=template&id=5ff5ec87"
import script from "./ticket-success.vue?vue&type=script&lang=ts"
export * from "./ticket-success.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff5ec87')) {
      api.createRecord('5ff5ec87', component.options)
    } else {
      api.reload('5ff5ec87', component.options)
    }
    module.hot.accept("./ticket-success.vue?vue&type=template&id=5ff5ec87", function () {
      api.rerender('5ff5ec87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ticket/ticket-success.vue"
export default component.exports